export default __webpack_public_path__ + "static/media/connect-5-white.55318146.svg";